<ng-container *transloco="let t">
  <pxw-modal-dialog [title]="t('endOrder.couponCodeNotAppliedTitle')" type="alert">
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <ul class="coupon-errors-list">
        @for (error of couponValidationErrors(); track error) {
          <li class="coupon-errors-item">
            {{ error }}
          </li>
        }
      </ul>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
